<template>
  <div class="register">
    <page-header />
    <page-prompt />
    <section class="main">
      <h2>注册账号</h2>
      <ul class="form">
        <li>
          <span>
            <el-input v-model="mobile" placeholder="请填写手机号码" />
          </span>
        </li>
        <li>
          <span>
            <el-input v-model="password" placeholder="请设置密码" show-password />
          </span>
        </li>
        <li>
          <span>
            <el-input class="input" v-model="imgCaptcha" placeholder="请填写图形验证码" />
            <img :src="`${DOMAIN.WEBSITE}/index.php?s=/captcha&r=${captchaRandom}`" @click="onRandomImgCaptcha" />
          </span>
        </li>
        <li>
          <span>
            <el-input class="input" v-model="smsCaptcha" placeholder="请填写短信验证码" />
            <el-button :disabled="smsTime > 0" @click="onGetSmsCaptcha">
              {{ smsTime > 0 ? smsTime + 's' : '获取验证码' }}
            </el-button>
          </span>
        </li>
      </ul>
      <el-button class="submit" type="primary" @click="onRegister">点击验证注册</el-button>
      <div class="btns">
        <router-link to="/login">返回登录</router-link>
      </div>
      <p class="prompt">浏览器使用建议：请使用谷歌、火狐或IE10以上的浏览器。</p>
    </section>
  </div>
</template>

<script>
import DOMAIN from '@/config/domain'
import PageHeader from '@/components/PageHeader'
import PagePrompt from '@/components/PagePrompt'
import { getsms, register } from '@/service/api'

export default {
  name: 'PageRegister',
  components: {
    PageHeader,
    PagePrompt
  },
  data () {
    return {
      DOMAIN,
      imgCaptcha: '',
      smsCaptcha: '',
      mobile: '',
      password: '',
      smsTime: 0,
      captchaRandom: (new Date()).getTime()
    }
  },
  methods: {
    onRandomImgCaptcha () {
      this.captchaRandom = (new Date()).getTime()
    },
    onGetSmsCaptcha () {
      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.mobile))) {
        this.$alert('手机号码填写错误!', '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!this.imgCaptcha) {
        this.$alert('图形验证码错误!', '提示', {
          confirmButtonText: '确定'
        })
        return
      }

      const loading = this.$loading({
        lock: true,
        text: '短信发送中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)'
      })

      getsms({
        mobile: this.mobile,
        imgCaptcha: this.imgCaptcha
      }).then(res => {
        loading.close()
        this.$message({
          message: '发送成功',
          type: 'success'
        })
        this.smsTime = 60
        this.interval = setInterval(() => {
          this.smsTime -= 1
          if (this.smsTime === 0) {
            clearInterval(this.interval)
          }
        }, 1000)
      }).catch(err => {
        loading.close()
        this.$message({
          message: err,
          type: 'warning'
        })
      })
    },
    onRegister () {
      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.mobile))) {
        this.$alert('手机号码填写错误!', '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!this.smsCaptcha) {
        this.$alert('短信验证码错误!', '提示', {
          confirmButtonText: '确认'
        })
        return
      }

      if (!this.password) {
        this.$alert('请设置密码!', '提示', {
          confirmButtonText: '确定'
        })
        return
      }

      if (this.password.length < 6) {
        this.$alert('密码不能小于6位!', '提示', {
          confirmButtonText: '确定'
        })
        return
      }

      this.$confirm('参赛队仅允许队长注册，且注册后队长身份不可变动，其他队员由队长进行添加已知悉 ', '注册提示', {
        confirmButtonText: '继续注册',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '注册中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.8)'
        })
        register({
          mobile: this.mobile,
          smsCaptcha: this.smsCaptcha,
          password: this.password
        }).then(res => {
          loading.close()
          this.$router.push('/basic')
        }).catch(err => {
          loading.close()
          this.$message({
            message: err,
            type: 'warning'
          })
        })
      }).catch(() => {
        console.log('取消')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
